import { StrictMode, lazy, Suspense, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import AppErrorBoundary from './components/AppErrorBoundary.jsx';
import './index.css';

const ClientReview=lazy(()=>import('./components/ClientReview.jsx'));
const HelpCentre=lazy(()=>import('./help/HelpCentre.jsx'));
function Root(){
 const [hash,setHash]=useState(window.location.hash);
 useEffect(()=>{const update=()=>setHash(window.location.hash);window.addEventListener('hashchange',update);return()=>window.removeEventListener('hashchange',update);},[]);
 return <Suspense fallback={<p>Loading…</p>}>
  {window.location.pathname==='/help'||window.location.pathname.startsWith('/help/')
   ? <HelpCentre/>
   : hash.startsWith('#review=')?<ClientReview key={hash}/>:<AppErrorBoundary><App/></AppErrorBoundary>}
 </Suspense>;
}
createRoot(document.getElementById('root')).render(
<StrictMode>
    <Root/>
</StrictMode>
);

